export default "__VITE_ASSET__Cktyx73J__"